module.exports = __webpack_public_path__ + "static/savings_walking-eb70a4016eb25fc061a420d437ca7d77.gif";